
































































































































import {
  POSActivitySession,
  POSProductCategory,
  POSProductCategoryGroup,
} from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPosProductSessionList from './pos-product-session-list.vue';
import BcPosCashMovements from './pos-cash-movements.vue';

@Component({
  name: 'bpc-pos-product-list',
  components: {
    BpcPosProductSessionList,
    BcPosCashMovements,
  },
})
export default class PosProductCategories extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number }) readonly contactId!: number;
  @Prop({ type: Number }) readonly activitySessionReloadKey!: number;
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;
  @Prop({ type: Boolean, default: false }) readonly changingTicket: boolean;
  @Prop({ type: Boolean, default: false }) readonly cashMovementsEnabled: boolean;

  // DATA
  productCategoryGroups: POSProductCategoryGroup[] = [];
  productCategoryGroupsLoaded = false;
  selectedProductCategoryGroup: POSProductCategoryGroup | null = null;
  filteredProductCategories: POSProductCategory[] = [];
  selectedProductCategories: POSProductCategory[] = [];
  showCashMovements = false;
  search = '';
  selectedTag: string = null;
  // COMPUTED
  get selectedProductCategoryIsEagerFetch() {
    return (
      this.selectedProductCategoryGroup &&
      this.selectedProductCategoryGroup?.productType !== 'attendee' &&
      this.selectedProductCategoryGroup?.productType !== 'booking'
    );
  }
  get selectedProductCategoryIsLazyFetch() {
    return this.selectedProductCategoryGroup && !this.selectedProductCategoryIsEagerFetch;
  }
  /* Lifecycle hooks */
  // created() {}
  mounted() {
    this.getProducts();
  }
  // updated() {}
  // destroyed() {}
  async getProducts() {
    this.productCategoryGroupsLoaded = false;
    this.productCategoryGroups = await this.$posService.getProductCategoryGroups(this.posSessionId);
    this.setDefaultProductCategoryGroup();
    this.productCategoryGroupsLoaded = true;
  }

  setDefaultProductCategoryGroup() {
    // NOTE For the moment we set the first product category group as default
    const defaultCategoryGroup = this.productCategoryGroups?.[0] || null;
    if (defaultCategoryGroup) {
      this.selectProductCategoryGroup(defaultCategoryGroup);
    }
  }

  onOpenCashMovementModalClicked(type: string) {
    this.$emit('open-cash-movement-modal', type);
  }

  async searchInProductCategories() {
    if (this.selectedProductCategoryIsLazyFetch) {
      return; // TODO implement the session and booking search
    }
    const filteredByTagProductCategories = !this.selectedTag
      ? this.selectedProductCategories
      : this.selectedProductCategories.filter(productCategory => {
          return productCategory.tags.includes(this.selectedTag);
        });
    this.filteredProductCategories = !this.search
      ? filteredByTagProductCategories
      : filteredByTagProductCategories.filter(productCategory => {
          const searchFields = [productCategory.name];
          const searchFieldsString = searchFields.join(' ').toLowerCase();
          return searchFieldsString.includes(this.search.toLowerCase());
        });
  }

  clearSearch() {
    this.search = '';
  }

  filterByTag(tagName: string) {
    this.selectedTag = tagName;
    this.searchInProductCategories();
  }

  clearTagFilter() {
    this.selectedTag = null;
    this.searchInProductCategories();
  }

  selectProductCategoryGroup(productCategoryGroup: POSProductCategoryGroup) {
    this.showCashMovements = false;
    this.selectedProductCategoryGroup = productCategoryGroup;
    this.selectedProductCategories = productCategoryGroup.categories;
    this.filteredProductCategories = productCategoryGroup.categories;
  }

  showCashMovement() {
    this.selectedProductCategoryGroup = null;
    this.showCashMovements = true;
  }

  productCategoryClicked(productCategory: POSProductCategory) {
    // TODO implement this
    console.log('productCategoryClicked', productCategory);
    this.$emit('product-category-clicked', productCategory);
  }

  addAttendee(session: POSActivitySession) {
    const productCategoryFromSession: POSProductCategory = {
      id: session.id,
      name: session.name,
      productType: 'attendee',
      color: '',
      adjustableQuantity: false,
      useSEPA: false,
      requiredSecondaryBadge: false,
      availableForAnonymousContact: false,
      tags: [],
    };
    this.$emit('product-category-clicked', productCategoryFromSession);
  }

  @Watch('search')
  onSearchChanged() {
    this.searchInProductCategories();
  }
}
